const INITIAL_STATE = {
  data: {},
  errors: {},
        
}
const getStandardCleaning = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_STANDARD_CLEANING_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_STANDARD_CLEANING_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default getStandardCleaning;